import { render, staticRenderFns } from "./x-icon.vue?vue&type=template&id=7ae3f7fc&"
import script from "./x-icon.vue?vue&type=script&lang=ts&"
export * from "./x-icon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ae3f7fc')) {
      api.createRecord('7ae3f7fc', component.options)
    } else {
      api.reload('7ae3f7fc', component.options)
    }
    module.hot.accept("./x-icon.vue?vue&type=template&id=7ae3f7fc&", function () {
      api.rerender('7ae3f7fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/components/x-icon.vue"
export default component.exports